import { faGift } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

type StampcardRewardPopupProps = {
  onRedeem: () => void;
  onClose: () => void;
};

export const StampcardRewardPopup = ({
  onRedeem,
  onClose
}: StampcardRewardPopupProps) => {
  return (
    <div className="flex w-full items-center justify-between gap-8 rounded-3xl bg-kiosk-accent-secondary p-7">
      <div className="flex items-center gap-4">
        <FontAwesomeIcon icon={faGift} size="3x" />
        <div>
          <p className="text-4xl font-bold text-kiosk-text-primary">
            <T _str="Reward available" />
          </p>
          <p className="text-2xl text-kiosk-text-primary">
            <T _str="Do you want to redeem it now?" />
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          className="p-8 text-4xl text-kiosk-text-primary"
          type="button"
          onClick={onClose}
        >
          <T _str="Close" />
        </button>

        <button
          className="rounded-3xl bg-kiosk-accent-secondary-alt p-8 text-4xl font-semibold text-kiosk-text-primary"
          type="button"
          onClick={onRedeem}
        >
          <T _str="Redeem reward" />
        </button>
      </div>
    </div>
  );
};
